import _CountDown from './CountDown';

export type { CountDownProps, CountDownRef } from './CountDown';
export * from './type';

export const CountDown = _CountDown;
export default CountDown;
